import React from 'react'
import { getInitialsColor, getInitialsFontScale, getTypeBubbleSize } from '../helpers/groupInitials'

export const typeBubbleWrapStyle = (typeAlias, size) => {
  const bubbleSize = size || getTypeBubbleSize(typeAlias)
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: bubbleSize,
    height: bubbleSize,
    lineHeight: 0,
  }
}

const GroupInitialsMark = ({ typeAlias, initials, size }) => {
  if (!initials) {
    return null
  }
  const bubbleSize = size || getTypeBubbleSize(typeAlias)
  const fontSize = (bubbleSize / 2) * 0.85 * getInitialsFontScale(typeAlias)
  return (
    <span
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        fontSize: `${fontSize}px`,
        fontWeight: 700,
        letterSpacing: '-0.05em',
        color: getInitialsColor(typeAlias),
        lineHeight: 1,
        userSelect: 'none',
      }}
    >
      {initials}
    </span>
  )
}

export default GroupInitialsMark
